var map = {
	"./$GMUSIC-icon.png": 2074,
	"./BAT-icon.png": 2075,
	"./BTC-icon.png": 2076,
	"./BXC-icon.png": 2077,
	"./CC-icon.png": 685,
	"./DistTest-icon.png": 2078,
	"./ETH-icon.png": 2079,
	"./ETIME-icon.png": 2080,
	"./ETIME[GYRI]-icon.png": 2081,
	"./GALA-icon.png": 1443,
	"./GALA[ETH]-icon.png": 2082,
	"./GALA[GYRI]-icon.png": 2083,
	"./GUSDC-icon.png": 2084,
	"./GUSDT-icon.png": 2085,
	"./GWBTC-icon.png": 2086,
	"./GWETH-icon.png": 2087,
	"./MTRM-icon.png": 2088,
	"./NODETESTCOIN-icon.png": 2089,
	"./SILK-icon.png": 2090,
	"./SILK[GYRI]-icon.png": 2091,
	"./SUPER-icon.png": 2092,
	"./TANK-icon.png": 2093,
	"./TCTESTCOIN-icon.png": 2094,
	"./TEST-icon.png": 2095,
	"./TOWN-icon.png": 2096,
	"./USD-icon.png": 2097,
	"./USDC-icon.png": 2098,
	"./USDT-icon.png": 2099,
	"./WBTC-icon.png": 2100,
	"./WETH-icon.png": 2101,
	"./coinpayments-icon.png": 2102,
	"./mastercard-icon.png": 683,
	"./simplex-icon.png": 1455,
	"./visa-icon.png": 684
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 911;